<template>
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- Title Banner Start -->
		<section class="title-banner">
			<div class="container-fluid">
				<div class="banner-wrapper">
					<img src="/assets/media/banner/left-image.png" alt="" class="banner-image1">
					<h1 class="dark-black fw-600">Мой аккаунт</h1>
					<img src="/assets/media/banner/right-image.png" alt="" class="banner-image2">
				</div>
			</div>
		</section>
		<!-- Title Banner End -->

		<!-- My Account Start -->
		<section class="my-account py-40">
			<div class="container-fluid">
				<div class="row row-gap-4 mb-3">
					<div class="col-xl-6 offset-xl-3">
						<div class="account">
							<h4 class="mb-12">Изменение анкетных данных</h4>
							<form @submit.prevent="doChangeQuestionary" class="contact-form">
								<div class="row">
									<div class="col-md-6">
										<div class="input-block mb-16">
											<input type="text" name="lastname" id="lastName" class="form-control" required placeholder="Фамилия" v-model="lastname">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M10 0C7.09223 0 4.72656 2.36566 4.72656 5.27344C4.72656 8.18121 7.09223 10.5469 10 10.5469C12.9078 10.5469 15.2734 8.18121 15.2734 5.27344C15.2734 2.36566 12.9078 0 10 0ZM10 9.375C7.7384 9.375 5.89844 7.53504 5.89844 5.27344C5.89844 3.01184 7.7384 1.17188 10 1.17188C12.2616 1.17188 14.1016 3.01184 14.1016 5.27344C14.1016 7.53504 12.2616 9.375 10 9.375Z"
													fill="#141516" />
												<path
													d="M16.5612 13.992C15.1174 12.5261 13.2035 11.7188 11.1719 11.7188H8.82812C6.79656 11.7188 4.88258 12.5261 3.43883 13.992C2.00215 15.4507 1.21094 17.3763 1.21094 19.4141C1.21094 19.7377 1.47328 20 1.79688 20H18.2031C18.5267 20 18.7891 19.7377 18.7891 19.4141C18.7891 17.3763 17.9979 15.4507 16.5612 13.992ZM2.40859 18.8281C2.70215 15.5045 5.46918 12.8906 8.82812 12.8906H11.1719C14.5308 12.8906 17.2979 15.5045 17.5914 18.8281H2.40859Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-6">
										<div class="input-block mb-16">
											<input type="text" name="name" id="firstName" class="form-control" required placeholder="Имя" v-model="firstname">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M10 0C7.09223 0 4.72656 2.36566 4.72656 5.27344C4.72656 8.18121 7.09223 10.5469 10 10.5469C12.9078 10.5469 15.2734 8.18121 15.2734 5.27344C15.2734 2.36566 12.9078 0 10 0ZM10 9.375C7.7384 9.375 5.89844 7.53504 5.89844 5.27344C5.89844 3.01184 7.7384 1.17188 10 1.17188C12.2616 1.17188 14.1016 3.01184 14.1016 5.27344C14.1016 7.53504 12.2616 9.375 10 9.375Z"
													fill="#141516" />
												<path
													d="M16.5612 13.992C15.1174 12.5261 13.2035 11.7188 11.1719 11.7188H8.82812C6.79656 11.7188 4.88258 12.5261 3.43883 13.992C2.00215 15.4507 1.21094 17.3763 1.21094 19.4141C1.21094 19.7377 1.47328 20 1.79688 20H18.2031C18.5267 20 18.7891 19.7377 18.7891 19.4141C18.7891 17.3763 17.9979 15.4507 16.5612 13.992ZM2.40859 18.8281C2.70215 15.5045 5.46918 12.8906 8.82812 12.8906H11.1719C14.5308 12.8906 17.2979 15.5045 17.5914 18.8281H2.40859Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-6">
										<div class="input-block mb-16">
											<input type="email" name="mail" autocomplete="off" class="form-control" placeholder="Ваш Email" v-model="email" required>
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M18.2422 2.96875H1.75781C0.786602 2.96875 0 3.76023 0 4.72656V15.2734C0 16.2455 0.792383 17.0312 1.75781 17.0312H18.2422C19.2053 17.0312 20 16.2488 20 15.2734V4.72656C20 3.76195 19.2165 2.96875 18.2422 2.96875ZM17.996 4.14062C17.6369 4.49785 11.4564 10.6458 11.243 10.8581C10.9109 11.1901 10.4695 11.3729 10 11.3729C9.53047 11.3729 9.08906 11.1901 8.75594 10.857C8.61242 10.7142 2.50012 4.63414 2.00398 4.14062H17.996ZM1.17188 15.0349V4.96582L6.23586 10.0031L1.17188 15.0349ZM2.00473 15.8594L7.06672 10.8296L7.9284 11.6867C8.48176 12.2401 9.21746 12.5448 10 12.5448C10.7825 12.5448 11.5182 12.2401 12.0705 11.6878L12.9333 10.8296L17.9953 15.8594H2.00473ZM18.8281 15.0349L13.7641 10.0031L18.8281 4.96582V15.0349Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-6">
										<div class="input-block mb-16">
											<input type="tel" name="phone" id="phoneNumber" class="form-control" placeholder="Телефон" v-model="phone">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M16.2509 15.5304L15.8338 14.8339C15.0836 13.5971 14.0484 12.1776 12.6904 12.1776C12.4389 12.1776 12.1897 12.2282 11.9431 12.3307L11.2142 12.6432C11.1477 12.6708 11.083 12.7022 11.0145 12.7355C10.828 12.8262 10.6165 12.929 10.3989 12.929C9.86217 12.929 9.2403 12.2305 8.64811 10.9623C8.06692 9.71762 8.10399 9.06508 8.23741 8.73673C8.38462 8.37447 8.72695 8.21959 9.09471 8.08041C9.14585 8.06101 9.19204 8.04342 9.23696 8.02493L9.97501 7.71418C11.8978 6.9101 11.1825 4.10014 10.948 3.17889L10.7491 2.3868C10.579 1.734 10.1282 0 8.63277 0C8.35594 0 8.06061 0.064496 7.75527 0.191774C7.55492 0.271334 4.79792 1.39672 3.79909 3.37382C2.60532 5.72716 2.82605 8.88296 4.45451 12.7515C6.07079 16.625 8.16669 18.9942 10.684 19.7933C11.1158 19.9305 11.6038 19.9999 12.1346 19.9999H12.1349C13.8721 19.9999 15.587 19.2608 15.7262 19.1994C16.3251 18.9457 16.7123 18.5601 16.8768 18.0532C17.1557 17.1937 16.6878 16.2519 16.2509 15.5304ZM15.5897 17.6356C15.5514 17.7534 15.4185 17.8609 15.1948 17.9551C15.1911 17.9567 15.1866 17.9586 15.1828 17.9603C15.1673 17.9672 13.615 18.647 12.1345 18.6469C11.7428 18.6469 11.3926 18.5988 11.0935 18.5037C8.97266 17.8305 7.1592 15.72 5.70231 12.2286C4.23459 8.7416 4.00006 5.96837 5.0062 3.98495C5.78746 2.43858 8.23335 1.45761 8.25734 1.44823C8.26221 1.44625 8.26699 1.44435 8.27177 1.44237C8.41105 1.38391 8.53589 1.35306 8.63277 1.35306C8.9309 1.35306 9.20223 1.81545 9.43803 2.72173L9.63602 3.51048C10.0632 5.18828 9.99819 6.23772 9.45129 6.46647L8.71675 6.77587C8.68753 6.78796 8.65334 6.80068 8.61563 6.81502C8.20989 6.96864 7.36558 7.28814 6.98375 8.22735C6.63727 9.0796 6.7807 10.1615 7.42178 11.535C8.28521 13.3835 9.25897 14.2821 10.3987 14.2821C10.9277 14.2821 11.3523 14.0757 11.6059 13.9525C11.6526 13.9298 11.6944 13.909 11.7393 13.8904L12.4693 13.5774C12.5446 13.546 12.6169 13.5307 12.6903 13.5307C13.0417 13.5307 13.6717 13.8786 14.6749 15.5325L15.0918 16.2285C15.6055 17.0767 15.6461 17.4618 15.5897 17.6356Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-12">
										<button type="submit" class="btn btn-primary" :disabled="btnDisabledQuestionary">Сохранить изменения</button>
									</div>
								</div>
							</form>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="errorQuestionary">
								{{errorQuestionary}}
								<button type="button" class="btn-close" aria-label="Close" @click="errorQuestionary = ''"></button>
							</div>
						</div>
					</div>
				</div>
				<div class="row row-gap-4 mb-3">
					<div class="col-xl-6 offset-xl-3">
						<div class="account">
							<h4 class="mb-12">Изменение контактных данных</h4>
							<form @submit.prevent="doChangeContacts" class="contact-form">
								<div class="row">
									<div class="col-md-4">
										<div class="input-block mb-16">
											<input type="text" name="country" id="region" class="form-control" placeholder="Страна" v-model="country">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M9.51246 19.7391C9.62113 19.9021 9.8041 20 10 20C10.1959 20 10.3789 19.9021 10.4875 19.7391C11.8742 17.6591 13.9167 15.0903 15.34 12.4778C16.478 10.3889 17.0312 8.60727 17.0312 7.03125C17.0312 3.15422 13.877 0 10 0C6.12297 0 2.96875 3.15422 2.96875 7.03125C2.96875 8.60727 3.52199 10.3889 4.66004 12.4778C6.08227 15.0883 8.12863 17.6634 9.51246 19.7391ZM10 1.17188C13.2309 1.17188 15.8594 3.80039 15.8594 7.03125C15.8594 8.40641 15.3529 10.0046 14.3109 11.9171C13.0841 14.1691 11.3334 16.4534 10 18.3738C8.66684 16.4537 6.91602 14.1692 5.6891 11.9171C4.64715 10.0046 4.14062 8.40641 4.14062 7.03125C4.14062 3.80039 6.76914 1.17188 10 1.17188Z"
													fill="#141516" />
												<path
													d="M10 10.5469C11.9385 10.5469 13.5156 8.96977 13.5156 7.03125C13.5156 5.09273 11.9385 3.51562 10 3.51562C8.06148 3.51562 6.48438 5.09273 6.48438 7.03125C6.48438 8.96977 8.06148 10.5469 10 10.5469ZM10 4.6875C11.2923 4.6875 12.3438 5.73891 12.3438 7.03125C12.3438 8.32359 11.2923 9.375 10 9.375C8.70766 9.375 7.65625 8.32359 7.65625 7.03125C7.65625 5.73891 8.70766 4.6875 10 4.6875Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-4">
										<div class="input-block mb-16">
											<input type="text" name="town" id="city" class="form-control" placeholder="Город / населенный пункт" v-model="city">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M9.51246 19.7391C9.62113 19.9021 9.8041 20 10 20C10.1959 20 10.3789 19.9021 10.4875 19.7391C11.8742 17.6591 13.9167 15.0903 15.34 12.4778C16.478 10.3889 17.0312 8.60727 17.0312 7.03125C17.0312 3.15422 13.877 0 10 0C6.12297 0 2.96875 3.15422 2.96875 7.03125C2.96875 8.60727 3.52199 10.3889 4.66004 12.4778C6.08227 15.0883 8.12863 17.6634 9.51246 19.7391ZM10 1.17188C13.2309 1.17188 15.8594 3.80039 15.8594 7.03125C15.8594 8.40641 15.3529 10.0046 14.3109 11.9171C13.0841 14.1691 11.3334 16.4534 10 18.3738C8.66684 16.4537 6.91602 14.1692 5.6891 11.9171C4.64715 10.0046 4.14062 8.40641 4.14062 7.03125C4.14062 3.80039 6.76914 1.17188 10 1.17188Z"
													fill="#141516" />
												<path
													d="M10 10.5469C11.9385 10.5469 13.5156 8.96977 13.5156 7.03125C13.5156 5.09273 11.9385 3.51562 10 3.51562C8.06148 3.51562 6.48438 5.09273 6.48438 7.03125C6.48438 8.96977 8.06148 10.5469 10 10.5469ZM10 4.6875C11.2923 4.6875 12.3438 5.73891 12.3438 7.03125C12.3438 8.32359 11.2923 9.375 10 9.375C8.70766 9.375 7.65625 8.32359 7.65625 7.03125C7.65625 5.73891 8.70766 4.6875 10 4.6875Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-4">
										<div class="input-block mb-16">
											<input type="text" name="postal" id="zip" class="form-control" placeholder="Индекс" v-model="postalCode">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M9.51246 19.7391C9.62113 19.9021 9.8041 20 10 20C10.1959 20 10.3789 19.9021 10.4875 19.7391C11.8742 17.6591 13.9167 15.0903 15.34 12.4778C16.478 10.3889 17.0312 8.60727 17.0312 7.03125C17.0312 3.15422 13.877 0 10 0C6.12297 0 2.96875 3.15422 2.96875 7.03125C2.96875 8.60727 3.52199 10.3889 4.66004 12.4778C6.08227 15.0883 8.12863 17.6634 9.51246 19.7391ZM10 1.17188C13.2309 1.17188 15.8594 3.80039 15.8594 7.03125C15.8594 8.40641 15.3529 10.0046 14.3109 11.9171C13.0841 14.1691 11.3334 16.4534 10 18.3738C8.66684 16.4537 6.91602 14.1692 5.6891 11.9171C4.64715 10.0046 4.14062 8.40641 4.14062 7.03125C4.14062 3.80039 6.76914 1.17188 10 1.17188Z"
													fill="#141516" />
												<path
													d="M10 10.5469C11.9385 10.5469 13.5156 8.96977 13.5156 7.03125C13.5156 5.09273 11.9385 3.51562 10 3.51562C8.06148 3.51562 6.48438 5.09273 6.48438 7.03125C6.48438 8.96977 8.06148 10.5469 10 10.5469ZM10 4.6875C11.2923 4.6875 12.3438 5.73891 12.3438 7.03125C12.3438 8.32359 11.2923 9.375 10 9.375C8.70766 9.375 7.65625 8.32359 7.65625 7.03125C7.65625 5.73891 8.70766 4.6875 10 4.6875Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-12">
										<div class="input-block mb-16">
											<input type="text" name="address" id="location" class="form-control" placeholder="Адрес" v-model="address">
											<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
												<path
													d="M9.51246 19.7391C9.62113 19.9021 9.8041 20 10 20C10.1959 20 10.3789 19.9021 10.4875 19.7391C11.8742 17.6591 13.9167 15.0903 15.34 12.4778C16.478 10.3889 17.0312 8.60727 17.0312 7.03125C17.0312 3.15422 13.877 0 10 0C6.12297 0 2.96875 3.15422 2.96875 7.03125C2.96875 8.60727 3.52199 10.3889 4.66004 12.4778C6.08227 15.0883 8.12863 17.6634 9.51246 19.7391ZM10 1.17188C13.2309 1.17188 15.8594 3.80039 15.8594 7.03125C15.8594 8.40641 15.3529 10.0046 14.3109 11.9171C13.0841 14.1691 11.3334 16.4534 10 18.3738C8.66684 16.4537 6.91602 14.1692 5.6891 11.9171C4.64715 10.0046 4.14062 8.40641 4.14062 7.03125C4.14062 3.80039 6.76914 1.17188 10 1.17188Z"
													fill="#141516" />
												<path
													d="M10 10.5469C11.9385 10.5469 13.5156 8.96977 13.5156 7.03125C13.5156 5.09273 11.9385 3.51562 10 3.51562C8.06148 3.51562 6.48438 5.09273 6.48438 7.03125C6.48438 8.96977 8.06148 10.5469 10 10.5469ZM10 4.6875C11.2923 4.6875 12.3438 5.73891 12.3438 7.03125C12.3438 8.32359 11.2923 9.375 10 9.375C8.70766 9.375 7.65625 8.32359 7.65625 7.03125C7.65625 5.73891 8.70766 4.6875 10 4.6875Z"
													fill="#141516" />
											</svg>
										</div>
									</div>
									<div class="col-md-12">
										<button type="submit" class="btn btn-primary" :disabled="btnDisabledContacts">Сохранить изменения</button>
									</div>
								</div>
							</form>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="errorContacts">
								{{errorContacts}}
								<button type="button" class="btn-close" aria-label="Close" @click="errorContacts = ''"></button>
							</div>
						</div>
					</div>
				</div>
				<div class="row row-gap-4 mb-3">
					<div class="col-xl-6 offset-xl-3">
						<div class="account">
							<h4 class="mb-12">Изменение пароля</h4>
							<form @submit.prevent="doChangePassword" class="contact-form">
								<div class="row">
									<div class="col-md-12">
										<div class="input-block mb-16">
											<input type="password" name="password" autocomplete="off" class="form-control" placeholder="Пароль" v-model="password" required>
											<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14C5.9 14 5 13.1 5 12S5.9 10 7 10 9 10.9 9 12 8.1 14 7 14M12.6 10C11.8 7.7 9.6 6 7 6C3.7 6 1 8.7 1 12S3.7 18 7 18C9.6 18 11.8 16.3 12.6 14H16V18H20V14H23V10H12.6Z" /></svg>
										</div>
									</div>
									<div class="col-md-12">
										<div class="input-block mb-16">
											<input type="password" name="password2" autocomplete="off" class="form-control" placeholder="Повтор пароля" v-model="password2" required>
											<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14C5.9 14 5 13.1 5 12S5.9 10 7 10 9 10.9 9 12 8.1 14 7 14M12.6 10C11.8 7.7 9.6 6 7 6C3.7 6 1 8.7 1 12S3.7 18 7 18C9.6 18 11.8 16.3 12.6 14H16V18H20V14H23V10H12.6Z" /></svg>
										</div>
									</div>
									<div class="col-md-12">
										<button type="submit" class="btn btn-primary" :disabled="btnDisabledChangePassword">Сменить пароль</button>
									</div>
								</div>
							</form>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="errorChangePassword">
								{{errorChangePassword}}
								<button type="button" class="btn-close" aria-label="Close" @click="errorChangePassword = ''"></button>
							</div>
						</div>
					</div>
				</div>
				<div class="row row-gap-4 mb-3">
					<div class="col-xl-6 offset-xl-3">
						<div class="account">
							<div class="contact-form">
								<div class="row">
									<div class="col-md-6">
										<button type="button" @click="doDeleteAccount" class="btn btn-outline-danger" :disabled="btnDisabledDeleteAccount">Удалить аккаунт</button>
									</div>
									<div class="col-md-6 text-end">
										<button type="button" @click="doLogout" class="btn btn-outline-primary">Выйти из аккаунта</button>
									</div>
								</div>
							</div>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="errorDeleteAccount">
								{{errorDeleteAccount}}
								<button type="button" class="btn-close" aria-label="Close" @click="errorDeleteAccount = ''"></button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- My Account End -->
		
		<benefits :footer-class="['bg-white', 'mt-40']" />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		firstname: '',
		lastname: '',
		email: '',
		phone: '',
		
		btnDisabledQuestionary: false,
		errorQuestionary: '',
		
		country: '',
		city: '',
		postalCode: '',
		address: '',
		
		btnDisabledContacts: false,
		errorContacts: '',
		
		password: '',
		password2: '',
		
		btnDisabledChangePassword: false,
		errorChangePassword: '',
		
		btnDisabledDeleteAccount: false,
		errorDeleteAccount: '',
	}),
	methods: {
		async doChangeQuestionary(){
			this.errorQuestionary = '';
			this.btnDisabledQuestionary = true;
			
			const params = {
				firstname: this.firstname,
				lastname: this.lastname,
				email: this.email,
				phone: this.phone,
			};
			const ret = await this.appModel.doChangeQuestionary(params);
			this.btnDisabledQuestionary = false;
			if(ret.success){
				this.authModel.userProfile.firstname = this.firstname;
				this.authModel.userProfile.lastname = this.lastname;
				this.authModel.userProfile.email = this.email;
				this.authModel.userProfile.phone = this.phone;
			} else {
				this.errorQuestionary = ret.error;
			}
		},
		async doChangeContacts(){
			this.errorContacts = '';
			this.btnDisabledContacts = true;
			
			const params = {
				country: this.country,
				city: this.city,
				postalCode: this.postalCode,
				address: this.address,
			};
			const ret = await this.appModel.doChangeContacts(params);
			this.btnDisabledContacts = false;
			if(ret.success){
				this.authModel.userProfile.country = this.country;
				this.authModel.userProfile.city = this.city;
				this.authModel.userProfile.postalCode = this.postalCode;
				this.authModel.userProfile.address = this.address;
			} else {
				this.errorContacts = ret.error;
			}
		},
		async doChangePassword(){
			this.errorChangePassword = '';
			this.btnDisabledChangePassword = true;
			
			const params = {
				password: this.password,
				password2: this.password2,
			};
			const ret = await this.appModel.doChangePassword(params);
			this.btnDisabledChangePassword = false;
			if(ret.success){
				this.password = '';
				this.password2 = '';
			} else {
				this.errorChangePassword = ret.error;
			}
		},
		async doDeleteAccount(){
			if (confirm('Вы уверены, что хотите удалить аккаунт?')) {
				this.errorDeleteAccount = '';
				this.btnDisabledDeleteAccount = true;
				
				const ret = await this.appModel.doDeleteAccount();
				this.btnDisabledDeleteAccount = false;
				if(ret.success){
					this.authModel.doLogout();
					this.$router.push({path: '/'});
				} else {
					this.errorDeleteAccount = ret.error;
				}
			}
		},
		doLogout(){
			if (confirm('Вы уверены, что хотите выйти из аккаунта?')) {
				this.authModel.doLogout();
				this.$router.push({path: '/'});
			}
		}
	},
	mounted(){
		window.scrollTo(0, 0);
		
		this.firstname = this.authModel.userProfile?.firstname||'';
		this.lastname = this.authModel.userProfile?.lastname||'';
		this.email = this.authModel.userProfile?.email||'';
		this.phone = this.authModel.userProfile?.phone||'';
		this.country = this.authModel.userProfile?.country||'';
		this.city = this.authModel.userProfile?.city||'';
		this.postalCode = this.authModel.userProfile?.postalCode||'';
		this.address = this.authModel.userProfile?.address||'';
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits,
	},
};
</script>